import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import { AuthContainer, AuthCard } from './styles/AuthStyles';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const Activate = () => {
  const { activationCode } = useParams();
  const [code, setCode] = useState(activationCode || '');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

  useEffect(() => {
    if (activationCode) {
      handleActivation(activationCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activationCode]);

  const handleActivation = async (codeToActivate) => {
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE}/api/auth/activate`, { activationCode: codeToActivate });
      setSnackbar({
        open: true,
        message: response.data.message || 'アカウントが有効化されました。',
        severity: 'success',
      });
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      console.error('アクティベーションエラー:', error);
      setSnackbar({
        open: true,
        message:
          error.response?.data?.error ||
          'アカウントの有効化に失敗しました。後ほど再度お試しください。',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code) {
      setSnackbar({
        open: true,
        message: 'アクティベーションコードを入力してください。',
        severity: 'warning',
      });
      return;
    }

    handleActivation(code);
  };

  return (
    <AuthContainer>
      <AuthCard>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          アカウントの有効化
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="アクティベーションコード"
            name="activationCode"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            required
            margin="normal"
          />
          <Box sx={{ position: 'relative', mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
            >
              有効化
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: 'primary.main',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )}
          </Box>
        </form>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CircularProgress />
          </Box>
        )}
      </AuthCard>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={8000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </AuthContainer>
  );
};

export default Activate;
